import Popper from 'popper.js/dist/popper';

class PopperHandler {
    constructor ($wrapper) {
        this.$wrapper = $wrapper;
        this.$reference = this.$wrapper.querySelector('[data-popper="ref"]');
        this.$tooltip = this.$wrapper.querySelector('[data-popper="tooltip"]');
        this.popper = null;
        this.debug = false;
    }

    init () {
        this.initializePopper();
        this.setEvents();
    }

    initializePopper () {
        this.popper = new Popper(this.$reference, this.$tooltip, {
            placement: 'top'
        });
    }

    setEvents () {
        this.$reference.addEventListener('click', () => {
            if (this.$reference.classList.contains('hover')) {
                this.$reference.classList.remove('hover');
            } else {
                this.$reference.classList.add('hover');
            }
        });
    }
}

export { PopperHandler };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$PopperHandler = $context.querySelectorAll('[data-popper="wrapper"]');
        for (let i = 0; i < $$PopperHandler.length; i++) {
            const $PopperHandler = new PopperHandler($$PopperHandler[i]);
            $PopperHandler.init();
        }
    }
});
